import { AppLinkTree } from "@megarax/links";

import { MegaraxNavSection } from "./MegaraxNavSection";

type Props = {
  linkTree: AppLinkTree[];
  onNavigate?: () => void;
};

export const NavLinkTreeSections: React.FC<Props> = ({ linkTree, onNavigate }) => (
  <div css={{ display: "flex", flexDirection: "column", gap: "0.875rem" }}>
    {linkTree.map((appTree) => (
      <MegaraxNavSection key={appTree.app} appTree={appTree} onNavigate={onNavigate} />
    ))}
  </div>
);
